import { useEffect, useState } from 'react';
import { isForbidden, organisationErrorMessage } from '../../organisations/lib/errorMessage';

/**
 * One school data section of a student's profile, fetched when its panel
 * mounts (the tab is opened) and again for each new student, never before.
 *
 * Returns { status, data, message } where status is:
 * - 'loading';
 * - 'ready', with `data`;
 * - 'forbidden' on a 403;
 * - 'off' on a 404: the school does not have the feature;
 * - 'error', with `message` from organisationErrorMessage.
 */
export function useStudentSection(fetchSection, studentId, fallbackMessage) {
  const [state, setState] = useState({ status: 'loading', data: null, message: '' });

  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading', data: null, message: '' });
    fetchSection(studentId)
      .then((data) => { if (!cancelled) setState({ status: 'ready', data, message: '' }); })
      .catch((err) => {
        if (cancelled) return;
        if (isForbidden(err)) setState({ status: 'forbidden', data: null, message: '' });
        else if (err?.status === 404) setState({ status: 'off', data: null, message: '' });
        else setState({ status: 'error', data: null, message: organisationErrorMessage(err, fallbackMessage) });
      });
    return () => { cancelled = true; };
  }, [fetchSection, studentId, fallbackMessage]);

  return state;
}
